import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';

import './styles.css';

import { InputSmall } from '../../Elements/Inputs';
import { ButtonSimple } from '../../Elements/Buttons';

import { changePassword } from '../../../Actions/users';
import {clientMedia, connection} from '../../../Config/Settings';

class ChangePassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
            confirmedPassword: '',
            name: ''
        }
    }

    componentWillMount() {
        axios.get(connection().serverUrl + '/api/users/get-name/'+ this.props.token).then(res=> {
            if (res.data && res.data.email) {
                this.setState({name: res.data.email.split('@')[0]})
            }
        })
    }

    onSubmit() {
        if (this.state.password !== this.state.confirmedPassword) {
            // TODO: connect to some warning logic
            alert('סיסמאות לא תואמות');
            return;
        }

        // TODO: connect to form validation errors
        if (this.state.password.length < 4) {
            console.log('סיסמא קצרה מידי');
            return;
        }

        if (!this.props.token) return;

        this.props.changePassword(this.state.password, this.props.token);
    }

    // Hi "<span>{this.state.name || "Stranger"}</span>" <br/>
    // Please enter your new password

    render() {
        return (
            <div className="change-password-wrapper rtl">
                <div className="flying-wrapper">
                    <img src={`${clientMedia()}/img/logos/flying-up-mugics.png`} alt="flying-logo"/>
                </div>
                <div className="content-wrapper">
                    <div className="text">
                        <p>
                             הי {this.state.name ? <span>{this.state.name}</span> : null}  <br/>
                            הקלידו סיסמא חדשה
                        </p>
                    </div>
                    <InputSmall
                        type="password"
                        placeholder="סיסמא חדשה"
                        onChange={(event) => this.setState({ password: event.target.value })}
                    />
                    <InputSmall
                        type="password"
                        placeholder="אימות סיסמא חדשה"
                        onChange={(event) => this.setState({ confirmedPassword: event.target.value })}
                    />
                    <ButtonSimple customClass="change-password-btn" onPress={() => this.onSubmit()} label="עדכן" />
                </div>
            </div>
        )
    }
}

ChangePassword.propTypes = {
    name: PropTypes.string,
    changePassword: PropTypes.func,
    token: PropTypes.string
};

export default connect(null, {changePassword})(ChangePassword);



// WEBPACK FOOTER //
// ./src/Components/ScreenElements/ChangePassword/ChangePassword.js